import React from 'react'
import * as UI from 'ui/index'
import { ForEachModel, useModel, useValue } from '@morningtrain/react-resources'
import without from 'lodash/without'
import RoleSelectorForPermission from 'pages/app/settings/permissions/partials/RoleSelectorForPermission'
import * as Displays from 'support/displays'

export default function InnerPermissionRoles () {
  const model = useModel()
  const selectedRoles = useValue('list_of_roles')

  const handleChange = (name, status) => {
    const newListOfRoles = without([...selectedRoles], name)

    if (status === true) {
      newListOfRoles.push(name)
    }

    model.set('list_of_roles', newListOfRoles)
  }

  return (
    <>
      <ForEachModel>
        <UI.SpaceBetween>
          <UI.WithSubtitle subtitle={<Displays.Text name='name' />}>
            <Displays.Text name='translated_name' />
          </UI.WithSubtitle>
          <RoleSelectorForPermission selectedRoles={selectedRoles} onChange={handleChange} />
        </UI.SpaceBetween>
      </ForEachModel>
    </>
  )
}
